module.exports = __webpack_public_path__ + "static/media/swingHardware1.88c1cfe7.png";